import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
// import CognosApi from '../../assets/js/cognosApi';

const firebaseRef = firebase.database();

export async function createCognosSession(callback) {
	var location = window.location.origin;
	try {
		console.log('running createCognosSession...');
		let currentUid = firebase.auth().currentUser.uid;

		let userRef = firebaseRef
			.ref('/kavtek_cognos_sessions/' + PROJECT_CODE.projectCode)
			.push();

		await userRef.update({
			expiresIn: 3600,
			webDomain: location,
			uid: currentUid,
			pushId: userRef.key,
			projectCode: PROJECT_CODE.projectCode,
		});

		console.log('this is the new key', userRef.key);

		await firebaseRef
			.ref(
				'/kavtek_cognos_sessions/' +
					PROJECT_CODE.projectCode +
					'/' +
					userRef.key +
					'/session'
			)
			.on('value', async (snapshot) => {
				console.log('createCognosSession callback', snapshot.val());

				var sessionNode = snapshot.val();

				if (sessionNode) {
					console.log(
						'sessionNode.sessionCode',
						sessionNode?.sessionCode
					);

					callback(sessionNode.sessionCode);
				}
			});
	} catch (error) {
		console.error(error.message);
	}
}
